import { isNumberFormat } from './isNumberFormat'

export function normalizeNumberInput(value: string): string | undefined {
  const normalizedValue = value.replace(',', '.')

  if (!isNumberFormat(normalizedValue)) return undefined

  return normalizedValue.startsWith('.') ? `0${normalizedValue}` : normalizedValue
}
